import React, { useContext } from 'react'
import { Grid, Header, Button, List, Label } from 'semantic-ui-react'
import ProfilePicture from '../ProfilePicture'
import DataContext from '../../../contexts/DataContext'

const View = ({ profile, onEdit }) => {
  const { advisor } = useContext(DataContext)
  return (
    <div id="profile-view">
      <div className="form-section">
        <Grid container stackable>
          <Grid.Row columns={2}>
            <Grid.Column width={5}>
              <ProfilePicture viewOnly />
            </Grid.Column>
            <Grid.Column
              width={11}
              textAlign="left"
              verticalAlign="middle"
              className="general-info-section"
            >
              <Label>{`$${profile.hourlyRate} / HR`}</Label>
              <Header>{advisor.fullName}</Header>
              <Header as="h4">
                {`${profile.title}, ${profile.organization.name}`}
              </Header>
              <Header as="h4">{`${profile.country} (${advisor.timeZone})`}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Grid container>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>About</Header>
                    <div className="content">{profile.description}</div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>Recent Experience</Header>
                    <div className="content">
                      <List bulleted>
                        {profile.employmentHistory.map((e) => (
                          <List.Item key={`${e.title}${e.organization.id}`}>
                            {`${e.isCurrent ? '(Current) ' : ''}${e.title}, ${
                              e.organization.name
                            }`}
                          </List.Item>
                        ))}
                      </List>
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>URLs</Header>
                    <div className="content">
                      {profile.publicLinks.length > 0 ? (
                        <List bulleted>
                          {profile.publicLinks.map((url) => (
                            <List.Item key={url}>{url}</List.Item>
                          ))}
                        </List>
                      ) : (
                        '(none)'
                      )}
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>Credentials</Header>
                    <div className="content">
                      {profile.credentials.length > 0 ? (
                        <List bulleted>
                          {profile.credentials.map((credential) => (
                            <List.Item key={credential}>{credential}</List.Item>
                          ))}
                        </List>
                      ) : (
                        '(none)'
                      )}
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>Expertise</Header>
                    <div className="content">
                      <List className="content-list">
                        <List.Item>
                          <List.Header>Functions</List.Header>
                          {profile.functions.length > 0 ? (
                            <List className="tags-section">
                              {profile.functions.map((t) => (
                                <Label key={t} size="small">
                                  {t}
                                </Label>
                              ))}
                            </List>
                          ) : (
                            '(none)'
                          )}
                        </List.Item>
                        <List.Item>
                          <List.Header>Technology</List.Header>
                          {profile.technology_tags.length > 0 ? (
                            <List className="tags-section">
                              {profile.technology_tags.map((t) => (
                                <Label key={t} size="small">
                                  {t}
                                </Label>
                              ))}
                            </List>
                          ) : (
                            '(none)'
                          )}
                        </List.Item>
                        <List.Item>
                          <List.Header>Medical Specialties</List.Header>
                          {profile.medical_specialties.length > 0 ? (
                            <List className="tags-section">
                              {profile.medical_specialties.map((t) => (
                                <Label key={t} size="small">
                                  {t}
                                </Label>
                              ))}
                            </List>
                          ) : (
                            '(none)'
                          )}
                        </List.Item>
                      </List>
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="section">
                  <Grid.Column>
                    <Header>
                      U.S Equal Employment Opportunity Information
                    </Header>
                    <div className="content">
                      <List className="content-list">
                        <List.Item>
                          <List.Header>Gender</List.Header>
                          {profile.gender || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Year of Birth</List.Header>
                          {profile.yearOfBirth || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Educational Achievement</List.Header>
                          {profile.education || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Primary Ethnicity</List.Header>
                          {profile.ethnicity || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Primary Language</List.Header>
                          {profile.language || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Veteran Status</List.Header>
                          {profile.veteran_status || '(Not specified)'}
                        </List.Item>
                        <List.Item>
                          <List.Header>Disability Status</List.Header>
                          {profile.disability_status || '(Not specified)'}
                        </List.Item>
                      </List>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <Button
        primary
        className="profile-btn-section"
        floated="right"
        onClick={onEdit}
      >
        Edit
      </Button>
    </div>
  )
}

export default View
